installedChunkData